// extracted by mini-css-extract-plugin
export var active = "_dd-7";
export var blink = "_dd-8";
export var dropDownSelector = "_dd-4";
export var dropDownWrapper = "_dd-3";
export var fakeCursor = "_dd-6";
export var fontSizeButton = "_dd-9";
export var formQuillEditor = "_dd-0";
export var pressed = "_dd-a";
export var qlBlank = "_dd-1";
export var textFormattingToolbar = "_dd-2";
export var textToolbarOption = "_dd-5";